import {createI18n} from "vue-i18n";

import messages from '@intlify/unplugin-vue-i18n/messages'

export const i18n = createI18n({
    legacy: false,
    locale: 'pl',
    fallbackLocale: 'pl',
    messages
})

export default i18n